module.exports = __webpack_public_path__ + "img/guia_hill.de7b22a2.jpg";